module.exports = __webpack_public_path__ + "static/media/logo.f309d2a0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/america-off-balance/logo.svg
// module id = 303
// module chunks = 0